import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TextUrlSkeleton } from "./TextUrl";

export interface MenuItemFields {
    title?: EntryFieldTypes.Symbol;
    url?: EntryFieldTypes.Symbol;
    subMenu?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<MenuItemSkeleton | TextUrlSkeleton>>;
    menuBannerImage?: EntryFieldTypes.AssetLink;
    hideMenuActionSection?: EntryFieldTypes.Boolean;
}

export type MenuItemSkeleton = EntrySkeletonType<MenuItemFields, "menuItem">;
export type MenuItem<Modifiers extends ChainModifiers = "WITHOUT_UNRESOLVABLE_LINKS", Locales extends LocaleCode = LocaleCode> = Entry<MenuItemSkeleton, Modifiers, Locales>;

export function isMenuItem<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is MenuItem<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'menuItem'
}
